"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withIntl = exports.createIntlMock = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var IntlWrapper_1 = require("./IntlWrapper");
var Locale_1 = require("./Locale");
var wrapDisplayName_1 = require("../react/wrapDisplayName");
/**
 * @internal
 */
function createIntlMock(customMessages, locale) {
    if (customMessages === void 0) { customMessages = {}; }
    if (locale === void 0) { locale = "en-US"; }
    return react_intl_1.createIntl({
        locale: locale,
        messages: tslib_1.__assign(tslib_1.__assign({}, IntlWrapper_1.messagesMap[locale]), customMessages),
    });
}
exports.createIntlMock = createIntlMock;
/**
 * @internal
 */
function withIntl(WrappedComponent, customLocale, customMessages) {
    var WithIntl = /** @class */ (function (_super) {
        tslib_1.__extends(WithIntl, _super);
        function WithIntl() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        WithIntl.prototype.render = function () {
            var locale = customLocale ? customLocale : Locale_1.DefaultLocale;
            var messages = customMessages ? customMessages : IntlWrapper_1.messagesMap[locale];
            return (react_1.default.createElement(react_intl_1.IntlProvider, { locale: locale, messages: messages },
                react_1.default.createElement(WrappedComponent, tslib_1.__assign({}, this.props))));
        };
        return WithIntl;
    }(react_1.default.Component));
    return wrapDisplayName_1.wrapDisplayName("withIntl", WrappedComponent)(WithIntl);
}
exports.withIntl = withIntl;
//# sourceMappingURL=intlUtils.js.map